var map = {
	"./avatar-paige-base-full.png": 97165,
	"./avatar-paige-fall-full.png": 72885,
	"./avatar-paige-spring-full.png": 90265,
	"./avatar-paige-summer-full.png": 23457,
	"./avatar-paige-travel-full.png": 16976,
	"./avatar-paige-winter-full.png": 43625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15132;